export default __webpack_public_path__ + "static/media/Boots of Fiendish Invocation.49d2fc7c.jpg";